'use client';

import { useEffect, useState } from 'react';
import { SubmitButton } from './SubmitButton';
import { useFormState } from 'react-dom';
import { addWaitlister } from '../actions/waitlist';
import { useTranslations } from 'next-intl';
import ams2Img from '../../../public/AMS2_Square.png';
import accImg from '../../../public/Assetto_Corsa_Competizione.png';
import iracingImg from '../../../public/iRacing-Icon-Color-White.svg';
import rf2Img from '../../../public/RFactor2_Logo.png';
import rennsportImg from '../../../public/rennsport.svg';
import lemansImg from '../../../public/LeMans-Logo-small.svg';
import Image from 'next/image';
import acImage from '../../../public/ac.png';
import r3eImg from '../../../public/r3e.png';
import {sendGTMEvent } from '@next/third-parties/google';

const games = [
  {
    id: 1,
    name: 'Automobilista 2',
    img: ams2Img,
  },
  {
    id: 4,
    name: 'rFactor 2',
    img: rf2Img,
  },
  {
    id: 2,
    name: 'Assetto Corsa Competizione',
    img: accImg,
  },
  {
    id: 3,
    name: 'iRacing',
    img: iracingImg,
  },
  {
    id: 5,
    name: 'Rennsport',
    img: rennsportImg,
  },
  {
    id: 6,
    name: 'Le Mans Ultimate',
    img: lemansImg,
  },
  {
    id: 7,
    name: 'RaceRoomRacing Experience',
    img: r3eImg,
  },
  {
    id: 8,
    name: 'Assetto Corsa',
    img: acImage,
  },
];

export default function WaitlistCTA() {
  const t = useTranslations('common');

  const initialState = {
    message: '',
  };

  const [state, formAction] = useFormState(addWaitlister, initialState);
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
    setIsSuccess(false);
    state.message = '';
  };

  useEffect(() => {
    if (state?.message === 'Success') {
      // sendGAEvent({ event: 'careerWaitlistSubmit',  value: 'submitSuccess' });
      sendGTMEvent({ event: 'careerWaitlistSubmit',  value: 'submitSuccess' });
      setIsSuccess(true);
    } else if (state?.message !== 'Success') {
      // sendGAEvent({ event: 'careerWaitlistSubmit',  value: 'submitError' });
      // sendGTMEvent({ event: 'careerWaitlistSubmit',  value: 'submitError' });
    }
  }, [state?.message]);

  useEffect(() => {
    const handleKeyDown = (event: { key: string; }) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }
  , [isOpen]);

  return (
    <>
      <button
        className="w-fit rounded-xl transition-colors duration-500 ease-in-out bg-primary px-4 py-2 text-xl font-semibold text-white shadow-[0_0_24px_12px_rgba(47,197,187,0.35)] hover:bg-opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        onClick={toggleModal}
      >
        {t('joinWaitlist')}
      </button>
      {isOpen && (
        <div className="text-main fixed top-1/2 md:left-1/2 transform md:-translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-75 backdrop-blur-md p-4 z-[1000] rounded-3xl">
          {!isSuccess ? (
            <>
              <h3 className="text-2xl">{t('joinWaitlist')}</h3>

              <form action={formAction} className="mt-4 space-y-6" id='waitlistForum'>
                <div className="space-y-3">
                  <div className="flex flex-col">
                    <label
                      htmlFor="waitlister-email"
                      className="block text-lg font-medium leading-6 text-gray-900"
                    >
                      Email
                    </label>
                    <div className="mt-1">
                      <input
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="mustmann@gmail.com"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <label
                      htmlFor="waitlister-email"
                      className="block text-lg font-medium leading-6 text-gray-900"
                    >
                      Name
                    </label>
                    <div className="mt-1">
                      <input
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                        type="text"
                        id="username"
                        name="username"
                        required
                        placeholder="edhor1608"
                      />
                    </div>
                  </div>
                </div>
                <div className="">
                  <label
                    htmlFor="waitlister-email"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    {t('yourGames')}
                  </label>
                  <hr className="mb-4 mt-2" />
                  <div className="space-y-4">
                    {games.map((game) => (
                      <label
                        key={game.id}
                        htmlFor={`game_${game.id}`}
                        className="relative flex items-center"
                      >
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id={`game_${game.id}`}
                            name={`game_${game.id}`}
                            value={`${game.name}`}
                            className="h-6 w-6 rounded border-gray-300 text-primary focus:ring-primary"
                          />
                        </div>
                        <div className="font-medium text-gray-900 flex flex-row space-x-2 items-center">
                          <div className="w-16 flex justify-center items-center">
                            <Image
                              src={game.img}
                              alt={game.name}
                              height={28}
                              className="max-w-10 drop-shadow-md"
                            />
                          </div>
                          <span className='drop-shadow-md'>{game.name}</span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
                <p aria-live="polite" role="status">
                  {state?.message === 'Success'
                    ? t('joinWaitlistSuccess')
                    : state?.message}
                </p>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                  <SubmitButton />
                </div>
              </form>
            </>
          ) : (
            <div className="flex items-center justify-center space-x-2">
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <span>{t('joinWaitlistSuccess')}</span>
            </div>
          )}
        </div>
      )}
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[999]"
          onClick={toggleModal}
        ></div>
      )}
    </>
  );
}
